import React, { useState } from 'react';
import { Modal, Form, Stack, Dropdown } from 'react-bootstrap';
import { Button, Icon, CountDown } from 'lb-components';
import { Api, useTranslation } from 'lb-store';
import { Flags } from '../../../assets/icons';
import _ from 'lodash';
import Config from 'lb-store/src/config/config';

import classes from './RegisterModal.module.scss';

const phoneIndexOptions = [
  { label: '+995', offset: '-176px 0' },
  { label: '+90', offset: '-64px -44px' },
  { label: '+7', offset: '-32px -88px' },
  { label: '+994', offset: '-144px -188px' },
  { label: '+374', offset: '-208px -55px' },
  { label: '+380', offset: '-48px -44px' },
  { label: '+7', offset: '-144px -44px' },
  { label: '+375', offset: '-192px -88px' },
];

export const RegisterModal = ({
  onSuccess,
  onCancel,
  isReferral,
  initialData,
  ...props
}) => {
  const [phoneIndex, setPhoneIndex] = useState(
    initialData?.phoneIndex
      ? _.find(phoneIndexOptions, (i) => {
          let formattedVal = initialData.phoneIndex.trim();
          if (!formattedVal.includes('+'))
            formattedVal = '+'.concat(formattedVal);

          return i.label === formattedVal;
        }) || phoneIndexOptions[0]
      : phoneIndexOptions[0]
  );
  const [data, setData] = useState();
  const [error, setError] = useState({});
  const [captchaIndex, setCaptchaIndex] = useState(0);
  const [timer, setTimer] = useState();
  const { t } = useTranslation();

  //initial -> captcha -> otp -> details
  const [stage, setStage] = useState(1);

  const generateData = (e) => {
    let formData;
    if (stage !== 4) {
      formData = {
        phoneIndex: phoneIndex.label,
        phone: e.target.phone.value.trim(),
        personalId: e.target.personalId.value.trim(),
      };
      if (stage === 2) {
        formData.captcha = e.target.captcha.value.trim();
      }
      if (stage === 3) {
        formData.sms = e.target.sms.value.trim();
      }
    } else {
      formData = {
        email: e.target.email.value.trim(),
        username: e.target.username.value.trim(),
        rules: e.target.rules.checked ? 1 : 0,
      };
      if (!isReferral) formData.password = e.target.password.value.trim();
    }
    return formData;
  };
  const validateForm = (formData) => {
    const err = {};
    _.map(formData, (value, key) => {
      if (!value || value === '') err[key] = 'გთხოვთ შეამოწმოთ ველი';
      else {
        switch (key) {
          case 'email':
            if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value))
              err[key] = 'ელ.ფოსტის ფორმატი არასწორია';
            break;
          case 'password':
            // length check
            if(value.trim().length <8){
              err[key] = 'პაროლი უნდა შედგებოდეს 8 სიმბოლოსგან'
              return;
            }

            if(!/\d/.test(value)){
              err[key] = 'პაროლი უნდა შეიცავდეს მინიმუმ 1 ასოს (a-z) და 1 რიცხვს (0-9)'
              return;
            }


            const weakStarts = ['123', 'qwe', 'asd', 'zxc'];


            if(weakStarts.some(i => value.toLowerCase().startsWith(i))) {
              err[key] = 'პაროლი ძალიან მარტივია';
              return
            }

            const usernameStart = formData.username.substring(0, 3).toLowerCase();
            if(usernameStart && value.toLowerCase().startsWith(usernameStart)) {
              err[key] = 'პაროლი არ უნდა იწყებოდეს მომხმარებლის სახელით'
            }

            break;
        }
      }
    });
    return err;
  };
  const submit = (formData) => {
    Api.Guest.Register({ isReferral, stage, data: formData }).then((res) => {
      //console.log(stage, res);

      //otp stage
      if (res.data.code === 'sms') {
        setStage(3);

        if (!res.data.res) setError({ sms: res.data.desc });
        setTimer(res.data.left);
      } else {
        if (res.status && res.data?.status === 1) {
          if (stage === 4) {
            //done
            window.trackLeaderBet('Registration');
            if (onSuccess)
              onSuccess({
                referralId: isReferral ? res.data?.data?.referral_id : null,
              });
            onCancel();
          } else {
            if (stage === 3) document.getElementById('registerForm').reset();
            setStage(stage + 1);

            setError({});
          }
        } else {
          //error
          const updatedError = res.data?.fields
            ? res.data.fields
            : { general: res.data?.desc };
          setError(updatedError);
          if (updatedError.captcha) {
            setCaptchaIndex(captchaIndex + 1);
            document.getElementById('captcha').value = '';
          }
        }
      }
    });
  };
  return (
    <Modal
      show
      centered
      onHide={onCancel}
      contentClassName={classes.modal}
      backdrop={'static'}
    >
      <Modal.Header
        closeButton
        closeVariant={'white'}
        style={{ fontSize: '1.5rem' }}
      >
        <Modal.Title className={classes.title}>
          {t('ახალი მომხმარებლის რეგისტრაცია')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={classes.body}>
        <p style={{ marginBottom: '2rem' }}>
          <span style={{ color: 'var(--bs-primary)' }}>
            {t('სავალდებულოა ყველა ველი შეივსოს სწორად.')}
          </span>
          <br />
          {t(
            'პირადი მონაცემების უზუსტობის შემთხვევაში, კომპანია იტოვებს უფლებას შეგიზღუდოთ საიტით სარგებლობა!'
          )}
        </p>
        <Form
          noValidate
          onSubmit={(e) => {
            e.preventDefault();
            const formData = generateData(e);
            const err = validateForm(formData);
            if (!_.isEmpty(err)) setError(err);
            else {
              setData(formData);
              submit(formData);
            }
          }}
          className={classes.form}
          id={'registerForm'}
        >
          {error?.general && (
            <Form.Group className={classes.formGroup} style={{ margin: 0 }}>
              <Form.Label style={{ color: 'var(--bs-danger)' }}>
                {t(error.general)}
              </Form.Label>
            </Form.Group>
          )}

          {stage !== 4 ? (
            <>
              <Form.Group className={classes.formGroup}>
                <Form.Label>{t('ტელეფონი')}</Form.Label>
                <div style={{ display: 'flex' }}>
                  <Dropdown className={classes.dropdown}>
                    <Dropdown.Toggle variant={'secondary'}>
                      <Icon
                        height={'11px'}
                        width={'16px'}
                        Icon={Flags}
                        classname={classes.flag}
                        style={{
                          backgroundPosition: phoneIndex.offset,
                        }}
                      />
                      {phoneIndex.label}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className={classes.menu}>
                      {phoneIndexOptions.map((item, index) => (
                        <Dropdown.Item
                          key={index}
                          as={'span'}
                          onClick={() => setPhoneIndex(item)}
                        >
                          <Icon
                            height={'11px'}
                            width={'16px'}
                            Icon={Flags}
                            classname={classes.flag}
                            style={{
                              backgroundPosition: item.offset,
                            }}
                          />
                          {item.label}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                  <Form.Control
                    name={'phone'}
                    defaultValue={initialData?.phone}
                  />
                </div>
                <Form.Control.Feedback
                  type='invalid'
                  className={classes.feedback}
                >
                  {t(error?.phone)}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className={classes.formGroup}>
                <Form.Label>{t('პირადი ნომერი')}</Form.Label>
                {/*<Form.Control name={"personalId"} defaultValue={initialData?.personalId} />*/}
                <Form.Control name={'personalId'} />
                <Form.Control.Feedback
                  type='invalid'
                  className={classes.feedback}
                >
                  {t(error?.personalId || error?.pid)}
                </Form.Control.Feedback>
              </Form.Group>
              {stage === 2 && (
                <Form.Group className={classes.formGroup}>
                  <Form.Label style={{ textAlign: 'start', display: 'flex' }}>
                    {t('დამცავი კოდი')}
                  </Form.Label>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'stretch',
                    }}
                  >
                    <div
                      style={{
                        maxWidth: '50%',
                        minWidth: '100px',
                        width: '100px',
                        height: '4rem',
                        display: 'flex',
                        backgroundColor: '#424242',
                        marginRight: '0.6rem',
                      }}
                    >
                      <img
                        src={`${Config.Captcha}${captchaIndex}`}
                        style={{ width: '100%', cursor: 'pointer' }}
                        alt='captcha'
                        onClick={() => setCaptchaIndex(captchaIndex + 1)}
                      />
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                      }}
                    >
                      <Form.Control
                        id={'captcha'}
                        name={'captcha'}
                        type={'number'}
                        style={{ flex: 1, marginBottom: '0.6rem' }}
                        isInvalid={error?.captcha}
                        onChange={(e) => {
                          setError({ ...error, captcha: undefined });
                        }}
                      />
                      <Form.Control.Feedback
                        type='invalid'
                        className={classes.feedback}
                      >
                        {t(error?.captcha)}
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </Form.Group>
              )}
              {stage === 3 && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>{t('მიუთითეთ SMS კოდი')}</Form.Label>
                    <div style={{ position: 'relative' }}>
                      <Form.Control
                        name={'sms'}
                        type={'number'}
                        isInvalid={error?.sms}
                        onChange={(e) => {
                          setError({ ...error, sms: undefined });
                        }}
                      />
                      {timer && (
                        <div
                          style={{
                            position: 'absolute',
                            right: error?.sms ? 25 : 2,
                            top: '50%',
                            transform: 'translateY(-50%) scale(0.85)',
                          }}
                        >
                          <CountDown
                            onComplete={() => setTimer(undefined)}
                            Duration={timer}
                            Colors={['#ffca2c']}
                            ColorsTime={[0]}
                            BackgroundColor={'#373940'}
                            /*StrokeWith={4}
                                      fontSize='1.3rem'*/
                          />
                        </div>
                      )}
                    </div>
                    <Form.Control.Feedback
                      type='invalid'
                      className={classes.feedback}
                    >
                      {t(error?.sms)}
                    </Form.Control.Feedback>
                    <div>
                      {!timer && (
                        <Form.Label
                          style={{
                            textDecoration: 'underline',
                            color: 'var(--bs-blue-gray)',
                            fontSize: '1.5rem',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setCaptchaIndex(0);
                            Api.Guest.Register({ stage: 1, data }).then(
                              (res) => {
                                //console.log(res);
                                if (res.status && res.data?.status === 1) {
                                  setStage(2);
                                } else {
                                  setError(
                                    res.data?.fields
                                      ? res.data.fields
                                      : { general: res.data?.desc }
                                  );
                                }
                              }
                            );
                          }}
                        >
                          {t('თავიდან გაგზავნა')}
                        </Form.Label>
                      )}
                    </div>
                  </Form.Group>
                </>
              )}
              <div className={classes.buttonsContainer}>
                <Button
                  variant={'success'}
                  type={'submit'}
                  style={{ marginRight: '2rem' }}
                >
                  {t('გაგრძელება')}
                </Button>
                <Button
                  variant={'secondary'}
                  type={'button'}
                  onClick={onCancel}
                >
                  {t('გაუქმება')}
                </Button>
              </div>
            </>
          ) : (
            <>
              <Form.Group className={classes.formGroup}>
                <Form.Label>{t('ელ.ფოსტა')}</Form.Label>
                <Form.Control name={'email'} />
                <Form.Control.Feedback
                  type='invalid'
                  className={classes.feedback}
                >
                  {t(error?.email)}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className={classes.formGroup}>
                <Form.Label>{t('მომხმარებლის სახელი')}</Form.Label>
                <Form.Control name={'username'} />
                <Form.Control.Feedback
                  type='invalid'
                  className={classes.feedback}
                >
                  {t(error?.username)}
                </Form.Control.Feedback>
              </Form.Group>
              {!isReferral && (
                <Form.Group className={classes.formGroup}>
                  <Form.Label>{t('პაროლი')}</Form.Label>
                  <Form.Control name={'password'} type={'password'} />
                  <Form.Control.Feedback
                    type='invalid'
                    className={classes.feedback}
                  >
                    {t(error?.password)}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
              <Form.Group className={classes.formGroup}>
                <div className={classes.rulesContainer}>
                  <Form.Check name={'rules'} />
                  <p>{t('ვეთანხმები საიტის წესებსა და პირობებს')}</p>
                </div>
                <Form.Control.Feedback
                  type='invalid'
                  className={classes.feedback}
                >
                  {t(error?.rules)}
                </Form.Control.Feedback>
              </Form.Group>

              <Stack
                direction={'horizontal'}
                gap={4}
                className={classes.buttonsContainer}
              >
                <Button type={'submit'}>{t('დასრულება')}</Button>
                <Button
                  variant={'secondary'}
                  type={'button'}
                  onClick={() => {
                    document.getElementById('registerForm').reset();
                    setStage(1);
                    setCaptchaIndex(0);
                  }}
                >
                  {t('დაბრუნება')}
                </Button>
              </Stack>
            </>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
};
